export default __webpack_public_path__ + "static/media/icon-comment.4f9ea26d.svg";